import * as React from "react";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthCard, SignupForm, SocialLogin } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";
import { recordSent } from "@/lib/resend-cooldown";
import { sessionStore } from "./session-store";
import { trackEvent } from "@/lib/umami";

export function SignupPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation("auth");
  const { email: initialEmail } = useSearch({ strict: false }) as { email?: string };

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/app" });
    }
  }, [user, navigate]);

  return (
    <AuthCard
      title={t("signup.title")}
      description={t("signup.subtitle")}
      footer={
        <>
          {t("signup.hasAccount")}{" "}
          <Link to="/login" className="font-medium text-primary hover:underline">
            {t("signup.signIn")}
          </Link>
        </>
      }
    >
      {/* Without email confirmation the new session redirects to /app (effect above). */}
      <SignupForm
        initialEmail={initialEmail}
        onSuccess={({ email, needsConfirmation }) => {
          trackEvent("signup_submitted");
          if (!needsConfirmation) return;
          recordSent(sessionStore(), email, Date.now());
          navigate({ to: "/signup/check-email", search: { email } });
        }}
      />
      <SocialLogin page="signup" />
    </AuthCard>
  );
}

export default SignupPage;
